import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { socket } from "../../../services/socket/socket";
import { useEffect } from "react";
import {
  UpdatePreset,
  getProjects,
} from "../../../Console/Component/services/apiHandler";
import { useState } from "react";
import AssociateBrowseModal from "../../../Console/Component/modal/associateModal";
import { useDispatch, useSelector } from "react-redux";
import { setAllChecksPreset } from "../../../redux/actions/actionPreset";
import { fetchPrepareConsoleData } from "../../../redux/actions/actionPrepareConsole";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchSubsidiaryConsoleData } from "../../../redux/actions/actionSubsidiaryData";
import Loader from "../../../helper/loader";



import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CheckIcon } from "../../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as ErrorIcon } from "../../../myfin_v2/assets/icons/warningred.svg";

const style_v2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1400,
  height: 670,
  bgcolor: "background.paper",
  outline: "none",
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 4,
};
// const label = { inputProps: { "aria-label": "Checkbox demo" } };

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const SubsidiarySelectModal = (props) => {
  const {
    isopen,
    handleIsClose,
    handleChange,
    workspaceData,
    presetIdData,
    CompanyName,
    prepareConsoleId
  } = props;
  const [openassociate, setOpenAssociate] = useState(false);
  const [associateId, setAssociateId] = useState("");
  const [consoldata, setConsolData] = useState([]);
  const [projectsData, setProjectsData] = useState([]);
  const [allcheckdata, setAllcheckData] = useState([]);
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectCheckDataAssociate, setSelectCheckDataAssociate] = useState([]);
  const [value, setValue] = useState(0);
  // const [tableData, SetInvestmentRegister] = useState([]);
  const [fieldOfIr, setFieldOfIr] = useState("");
  const subsidiaryData = useSelector((state) => state.SubsidiaryConsoleReducer);

  const prepareConsoleData = useSelector(
    (state) => state.PrepareConsoleReducer
  );

  const { prepareConsole } = useSelector((state) => state.miscellaneousReducer);

  const dispatch = useDispatch();
  useEffect(() => {
    getCompanyData();
    if (prepareConsoleId && subsidiaryData.set_payload !== prepareConsoleId) {
      dispatch(fetchSubsidiaryConsoleData(prepareConsoleId));
    }

    if (prepareConsoleData.set_payload !== presetIdData) {
      dispatch(fetchPrepareConsoleData(presetIdData));
    }
    // fetchInvestCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prepareConsoleId, presetIdData]);


  useEffect(() => {
    if (subsidiaryData.isSuccess && prepareConsoleData.isSuccess) {
      let resultSet = [];
      subsidiaryData.response.otherData.forEach((subsidiary) => {
        let consolidation = prepareConsoleData?.response?.getOnePreCompany[0]?.consolidation;
        const exist = consolidation.find(
          (consol) => consol.Ir_id === subsidiary._id
        );
        if (exist) {
          resultSet.push(exist)
        }
      })
      setSelectCheckData(resultSet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subsidiaryData, prepareConsoleData])

  const browseConsol = (project_id, field) => {
    setAssociateId(project_id);
    setOpenAssociate(true);
    setFieldOfIr(field);
  };
  const handleClose = () => {
    setOpenAssociate(false);
  };
  const uploadPresetToSubsidiary = (project_id, prepare_console_id, field) => {
    if (field === "Subsidiary Company") {
      const objIndex =
        prepareConsoleData?.response?.getOnePreCompany[0]?.subsidiary_upload_preset?.findIndex(
          (data) => data.prepare_console_id === prepare_console_id
        );
      if (objIndex === -1) {
        prepareConsoleData?.response?.getOnePreCompany[0]?.subsidiary_upload_preset.push(
          {
            project_id: project_id,
            prepare_console_id: prepare_console_id,
          }
        );
      } else {
        prepareConsoleData.response.getOnePreCompany[0].subsidiary_upload_preset[
          objIndex
        ]["project_id"] = project_id;
      }
      setConsolData(prepareConsoleData?.response?.getOnePreCompany[0]);
      dispatch(fetchPrepareConsoleData(prepareConsole._id));
    } else {
      const objIndex =
        prepareConsoleData?.response?.getOnePreCompany[0]?.associate_upload_preset?.findIndex(
          (data) => data.prepare_console_id === prepare_console_id
        );
      if (objIndex === -1) {
        prepareConsoleData?.response?.getOnePreCompany[0]?.associate_upload_preset.push(
          {
            project_id: project_id,
            prepare_console_id: prepare_console_id,
          }
        );
      } else {
        prepareConsoleData.response.getOnePreCompany[0].associate_upload_preset[
          objIndex
        ]["project_id"] = project_id;
      }
      setConsolData(prepareConsoleData?.response?.getOnePreCompany[0]);
    }
  };
  const getCompanyData = async () => {
    try {
      const response = await getProjects();
      setProjectsData(response.data.project);
    } catch (err) {
      console.log("err", err.response);
    }
  };
  const getProjectName = (p_id) => {
    try {
      if (!p_id) return "";
      const nameOfType = projectsData.filter((adj) => adj._id === p_id);
      const result = nameOfType[0]?.project_name
        ? nameOfType[0]?.project_name
        : "";
      return result;
    } catch (err) {
      console.log("err", err.message);
    }
  };
  const newGetProjectName = (subsidiary_id, getId = false) => {
    try {
      const subsidiary_upload_preset =
        prepareConsoleData?.response?.getOnePreCompany[0]
          ?.subsidiary_upload_preset;
      let projectData = subsidiary_upload_preset?.find(
        (obj) => obj?.prepare_console_id === subsidiary_id
      );
      if (getId) {
        return projectData?.project_id;
      }
      return getProjectName(projectData?.project_id);
    } catch (err) {
      console.log("err", err.message);
    }
  };

  const consolidateChange = (e, data, project_id, field) => {
    if (field === "Subsidiary Company") {
      if (e.target.checked) {
        let dataValue = {
          all_data: data,
          project_id: project_id,
        };
        setAllcheckData([...allcheckdata, dataValue]);

        let checkData = {
          Ir_id: data._id,
          project_id: project_id,
        };
        setSelectCheckData([...selectCheckData, checkData]);
      } else {
        setAllcheckData(
          allcheckdata.filter((item) => item.all_data._id !== data._id)
        );
        setSelectCheckData(
          selectCheckData.filter((item) => item.Ir_id !== data._id)
        );
      }
    } else {
      if (e.target.checked) {
        let checkData = {
          Ir_id: data._id,
          project_id: project_id,
        };
        setSelectCheckDataAssociate([...selectCheckDataAssociate, checkData]);
      } else {
        setSelectCheckDataAssociate(
          selectCheckDataAssociate.filter((item) => item.Ir_id !== data._id)
        );
      }
    }

  };

  const saveModalCheck = async () => {
    let data = {
      Consolidate: selectCheckData,
      AssociateConsolidate: selectCheckDataAssociate
    };
    const res = await UpdatePreset(data, prepareConsole._id);
    dispatch(fetchPrepareConsoleData(presetIdData));

    if (res.status === 200) {
      socket.emit("request-prepare-console", {
        prepare_console_id: prepareConsole._id,
      });
      dispatch(setAllChecksPreset(selectCheckData));
      handleIsClose();
    }
  };

  const checkConsolidated = (ir_id) => {
    try {
      const exist =
        prepareConsoleData?.response?.getOnePreCompany[0]?.consolidation.find(
          (consol) => consol.Ir_id === ir_id
        );
      if (exist) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("error", err.message);
      return false;
    }
  };

  const checkConsolidatedAssociate = (ir_id) => {
    try {
      const exist =
        prepareConsoleData?.response?.getOnePreCompany[0]?.AssociateConsolidate.find(
          (consol) => consol.Ir_id === ir_id
        );
      if (exist) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("error", err.message);
      return false;
    }
  }
  useEffect(() => {
    console.log("value", value);

  }, [value])
  return (
    <>
      {isopen && (
        <Modal
          title="Investees"
          bodycss={commoncss.unsetPadding}
          width="75%"
          headerActions={
            <CloseIcon
              onClick={handleIsClose}
              className="clickable"
            />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleIsClose}
                label="Cancel"
              />

              <Button
                btnColor={buttoncss.primary}
                label="Save Changes"
                onClick={saveModalCheck}
              />
            </>
          }
        >
          <div className={commoncss.pd1530}>
            <div className={commoncss.bdrBr}>
              <div style={{ "border-bottom": "1px solid #eaeeed" }}>
                <button
                  className={`tab-button ${value === 0 ? "active" : ""}`}
                  onClick={() => {
                    setValue(0);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset", "border-top-left-radius": "10px" }}
                >
                  Subsidiary companies
                </button>
                <button
                  className={`tab-button ${value === 1 ? "active" : ""}`}
                  onClick={() => {
                    setValue(1);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset" }}
                >
                  Joint ventures
                </button>
                <button
                  className={`tab-button ${value === 2 ? "active" : ""}`}
                  onClick={() => {
                    setValue(2);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset" }}
                >
                  Investments
                </button>
              </div>
              <CustomTabPanel
                value={value}
                index={0}
              >
                <div className={standalonecss.standaloneTableContainer}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>
                        <th className={`${commoncss.p12_5} text-center`}>VALIDATION CHECK</th>
                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    {subsidiaryData.loading || prepareConsoleData.loading ? (
                      <Loader />
                    ) : subsidiaryData?.response?.getSubsidiaryData?.length >
                      0 ? (
                      <>
                        {subsidiaryData?.response?.otherData?.filter(
                          (name) =>
                            name.holdings > "50" &&
                            name.nature_of_relationship ===
                            "Subsidiary Company"
                        )
                          .map((subsiary, key) => {
                            return (
                              <>

                                <tbody>
                                  <tr
                                  >
                                    <td className={``}
                                    >
                                      {CompanyName(subsiary?.investment_company_id)}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}
                                    >
                                      {subsiary?.value_of_investment}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}>
                                      {parseInt(subsiary?.holdings)}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      <span className={commoncss.dFlexClm}>
                                        <Button
                                          btnColor={buttoncss.secondary}
                                          class_={commoncss.p5}
                                          label="Select Preset"
                                          onClick={() =>
                                            browseConsol(
                                              subsiary._id,
                                              "Subsidiary Company"
                                            )
                                          }
                                        />
                                        <span>{newGetProjectName(subsiary._id)}</span>
                                      </span>
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      {newGetProjectName(subsiary._id) ? (
                                        <span><CheckIcon /> <span className={`${commoncss.fs14} ${commoncss.color3}`}>Validated</span></span>
                                      ) : (
                                        <span><ErrorIcon height={19} width={19} style={{ "margin-bottom": "2px" }} /> <span className={`${commoncss.fs14}`} style={{ color: "red" }}>Error</span></span>
                                      )}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}>
                                      <CheckBoxComp
                                        label={"label"}
                                        consolidated={checkConsolidated(
                                          subsiary._id
                                        )}
                                        consolidateChange={consolidateChange}
                                        filteredName={subsiary}
                                        newGetProjectName={newGetProjectName}
                                        field={"Subsidiary Company"}
                                        sx={{
                                          color: "green",
                                          "&.Mui-checked": {
                                            color: "green",
                                          },
                                        }}
                                      />
                                    </td>
                                  </tr>

                                </tbody>
                              </>
                            );
                          })}
                      </>
                    ) : (
                      "Something went wrong"
                    )}
                  </table>
                </div>
              </CustomTabPanel>
              <CustomTabPanel
                value={value}
                style={{ marginTop: "10px" }}
                index={1}
              >

                <div className={standalonecss.standaloneTableContainer}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>
                        <th className={`${commoncss.p12_5} text-center`}>VALIDATION CHECK</th>
                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    {subsidiaryData.loading && !subsidiaryData.response ? (
                      ""
                    ) : subsidiaryData?.response?.getSubsidiaryData?.length >
                      0 ? (
                      <>
                        {subsidiaryData?.response?.getSubsidiaryData
                          ?.filter(
                            (name) =>
                              name.final_holdings <= "50" &&
                              name.final_holdings >= "20" &&
                              name.nature_of_relationship ===
                              "Associate Company"
                          )
                          .map((subsiary, key) => {
                            return (
                              <>

                                <tbody>
                                  <tr
                                  >
                                    <td className={``}
                                    >
                                      {CompanyName(subsiary?.company)}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}
                                    >
                                      {subsiary?.value_of_investment}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}>
                                      {subsiary?.final_holdings}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      <span className={commoncss.dFlexClm}>
                                        <Button
                                          btnColor={buttoncss.secondary}
                                          class_={commoncss.p5}
                                          label="Select Preset"
                                          onClick={() =>
                                            browseConsol(
                                              subsiary._id,
                                              "Associate Company"
                                            )
                                          }
                                        />
                                        <span>{newGetProjectName(subsiary._id)}</span>
                                      </span>
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      {newGetProjectName(subsiary._id) ? (
                                        <span><CheckIcon /> <span className={`${commoncss.fs14} ${commoncss.color3}`}>Validated</span></span>
                                      ) : (
                                        <span><ErrorIcon height={19} width={19} style={{ "margin-bottom": "2px" }} /> <span className={`${commoncss.fs14}`} style={{ color: "red" }}>Error</span></span>
                                      )}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}>
                                      <CheckBoxComp
                                        label={"label"}
                                        consolidated={checkConsolidatedAssociate(
                                          subsiary._id
                                        )}
                                        consolidateChange={consolidateChange}
                                        filteredName={subsiary}
                                        newGetProjectName={newGetProjectName}
                                        field={"Associate Company"}
                                      />
                                    </td>
                                  </tr>

                                </tbody>
                              </>
                            );
                          })}
                      </>
                    ) : (
                      "Something went wrong"
                    )}
                  </table>
                </div>
              </CustomTabPanel>
              <CustomTabPanel
                value={value}
                style={{ marginTop: "10px" }}
                index={2}
              >

                <div className={standalonecss.standaloneTableContainer}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>
                        <th className={`${commoncss.p12_5} text-center`}>VALIDATION CHECK</th>
                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    {subsidiaryData.loading && !subsidiaryData.response ? (
                      ""
                    ) : subsidiaryData?.response?.getSubsidiaryData?.length >
                      0 ? (
                      <>
                        {subsidiaryData?.response?.getSubsidiaryData
                          ?.filter(
                            (name) =>
                              name.final_holdings < "20" &&
                              name.nature_of_relationship === "Investment"
                          )
                          .map((subsiary, key) => {
                            return (
                              <>

                                <tbody>
                                  <tr
                                  >
                                    <td className={``}
                                    >
                                      {CompanyName(subsiary?.company)}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}
                                    >
                                      {subsiary?.value_of_investment}
                                    </td>
                                    <td className={`${commoncss.p12_5}`}>
                                      {subsiary?.final_holdings}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      <span className={commoncss.dFlexClm}>
                                        <Button
                                          btnColor={buttoncss.secondary}
                                          class_={commoncss.p5}
                                          label="Select Preset"
                                          onClick={() =>
                                            browseConsol(
                                              subsiary._id,
                                              "Investment"
                                            )
                                          }
                                        />
                                        <span>{newGetProjectName(subsiary._id)}</span>
                                      </span>
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}
                                    >
                                      {newGetProjectName(subsiary._id) ? (
                                        <span><CheckIcon /> <span className={`${commoncss.fs14} ${commoncss.color3}`}>Validated</span></span>
                                      ) : (
                                        <span><ErrorIcon height={19} width={19} style={{ "margin-bottom": "2px" }} /> <span className={`${commoncss.fs14}`} style={{ color: "red" }}>Error</span></span>
                                      )}
                                    </td>
                                    <td className={`${commoncss.p12_5} text-center`}>
                                      <CheckBoxComp
                                        label={"label"}
                                        consolidated={checkConsolidated(
                                          subsiary._id
                                        )}
                                        consolidateChange={consolidateChange}
                                        filteredName={subsiary}
                                        newGetProjectName={newGetProjectName}
                                        field={"Investment"}
                                      />
                                    </td>
                                  </tr>

                                </tbody>
                              </>
                            );
                          })}
                      </>
                    ) : (
                      "Something went wrong"
                    )}
                  </table>
                </div>
              </CustomTabPanel>
            </div>
          </div>
        </Modal>
      )}

      {openassociate && (
        <AssociateBrowseModal
          handleClose={handleClose}
          open={openassociate}
          selectedAssociateId={associateId}
          setPresetHandler={uploadPresetToSubsidiary}
          projectsData={projectsData}
          prepareConsoleId={presetIdData}
          nature={fieldOfIr}
          workspaceData={workspaceData}
          consoldata={consoldata}
        />

      )}
    </>
  );
};

export default SubsidiarySelectModal;

const CheckBoxComp = (props) => {
  const {
    label,
    consolidated,
    consolidateChange,
    filteredName,
    newGetProjectName,
    field
  } = props;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(consolidated);
  }, [consolidated]);

  const handleChange = (event, field) => {
    setChecked(event.target.checked);
    consolidateChange(
      event,
      filteredName,
      newGetProjectName(filteredName._id, true),
      field
    );
  };

  return <Checkbox {...label} checked={checked} onChange={(e) => handleChange(e, field)} sx={{
    color: "#7ECEA7",            // unchecked color (border)
    "&.Mui-checked": {
      color: "#183930",          // checked color (tick + fill)
    },
  }} />;
};
